import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getRacksAPI } from "../../../api/racks";
import { getCarrierTypesError, getCarrierTypesSuccess } from "./actions";
// Login Redux States
import { GET_CARRIER_TYPES } from "./actionTypes";

const racksAPI = getRacksAPI();

function* getCarrierTypesApi({ payload: { user } }) {
  try {
    const response = yield call(racksAPI.getCarrierTypes, user.token);
    yield put(getCarrierTypesSuccess(response.message, response.carrier_types));
  } catch (error) {
    yield put(getCarrierTypesError(error));
  }
}

export function* watchGetCarrierTypes() {
  yield takeEvery(GET_CARRIER_TYPES, getCarrierTypesApi);
}

function* getCarrierTypesSaga() {
  yield all([fork(watchGetCarrierTypes)]);
}

export default getCarrierTypesSaga;
